import { gql } from '@apollo/client';

import SIGNED_URLS_FRAGMENT from '../fragments/signedUrls';

export const GET_MANY_SIGNED_URLS = gql`
  ${SIGNED_URLS_FRAGMENT}
  query getManySignedUrls($fileList: [SignedUrlFileInput!]!) {
    getManySignedUrls(fileList: $fileList) {
      ...SignedUrlsFragment
    }
  }
`;
